import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

import type { UseAuthUserReturn } from '@/composables/use-auth-user/useAuthUser.types'
import type { User } from '@/domains/users/types/models/User.types'

/**
 * Typed access to the authenticated user from Inertia shared props.
 *
 * Centralises the `page.props.auth as { user?: User } | undefined` cast so
 * components don't have to reinvent it. Returns `undefined` when the
 * request is unauthenticated or the auth prop is missing.
 */
export const useAuthUser = (): UseAuthUserReturn => {
  const page = usePage()
  const user = computed(() => (page.props.auth as { user?: User } | undefined)?.user)

  return { user }
}
